
const nutricionista = {
  state: {
    userId: null
  },
  mutations: {
    setUserId (state, userId) {
      state.userId = userId
    }
  },
  actions: {
    setUserId ({ commit }, userId) {
      console.log('aaaaaaaaaaaaaaaa foi')
      commit('setUserId', userId)
    }
  }
}

export default nutricionista
